module.exports = __webpack_public_path__ + "static/media/service_tile_calcio.7cdb08e5.jpg";